import React from "react";
// Utils
import theme from "../../theme.scss";

interface NoDataIconProps {
  width?: number | string;
  x?: number;
  y?: number;
  yShift?: number;
  xShift?: number;
  opaque?: boolean;
  viewbox?: string;
  color?: string;
}

export const NoDataIcon = ({
  width,
  x,
  y,
  yShift,
  xShift,
  opaque,
  viewbox,
  color,
}: NoDataIconProps) => {
  return (
    <svg
      width={width || 30}
      y={y + (yShift || 0)}
      x={x + (xShift || 0)}
      viewBox={viewbox || "0 0 30 30"}
      id="NoDataIcon"
    >
      <path
        d="M10.125 15.2227C10.125 15.8634 9.60562 16.3828 8.96484 16.3828C8.32407 16.3828 7.80469 15.8634 7.80469 15.2227C7.80469 14.582 8.32407 14.0625 8.96484 14.0625C9.60562 14.0625 10.125 14.582 10.125 15.2227ZM6.62379 3.2514C7.39613 3.07686 8.19553 2.98828 9.00014 2.98828C11.9769 2.98828 14.7406 4.19485 16.7826 6.38567C16.921 6.53426 17.1087 6.60938 17.297 6.60938C17.4687 6.60938 17.6407 6.54689 17.7763 6.42068C18.0604 6.15591 18.0759 5.71097 17.8113 5.42683C15.5005 2.94749 12.3713 1.58203 8.99986 1.58203C8.09143 1.58203 7.18767 1.68214 6.31384 1.87976C5.93495 1.96532 5.69737 2.34174 5.78293 2.72049C5.86848 3.09938 6.24504 3.3371 6.62379 3.2514ZM9.67923 6.36287C9.61015 6.74506 9.8638 7.11076 10.246 7.17998C11.7291 7.44818 13.1072 8.18852 14.2313 9.32121C14.3687 9.45964 14.5496 9.52899 14.7303 9.52899C14.9094 9.52899 15.0886 9.46101 15.2257 9.32492C15.5013 9.05136 15.5029 8.60614 15.2294 8.33052C13.9011 6.99225 12.2645 6.11595 10.4962 5.79611C10.1142 5.7269 9.74831 5.98082 9.67923 6.36287V6.36287ZM17.794 16.7997L1.20026 0.205994C0.925735 -0.0686646 0.480515 -0.0686646 0.205994 0.205994C-0.0686646 0.480515 -0.0686646 0.925735 0.205994 1.20039L2.4939 3.4883C1.6588 4.02965 0.885635 4.67921 0.188828 5.42697C-0.075943 5.71097 -0.0602875 6.15591 0.223709 6.42068C0.359253 6.54689 0.531326 6.60938 0.702988 6.60938C0.891266 6.60938 1.07899 6.53426 1.21756 6.38567C1.90613 5.64684 2.67723 5.01663 3.51357 4.50797L5.45059 6.44499C4.46992 6.89735 3.55696 7.53786 2.77034 8.33066C2.49678 8.60628 2.49857 9.0515 2.77419 9.32506C2.91138 9.46115 3.09032 9.52899 3.26939 9.52899C3.45026 9.52899 3.63112 9.45964 3.76859 9.32121C4.57855 8.50479 5.5047 7.90027 6.52505 7.51945L8.78275 9.77715C7.63055 9.82425 6.39391 10.3764 5.51939 11.2427C5.24364 11.516 5.24158 11.9612 5.51486 12.2371C5.65233 12.3758 5.83333 12.4453 6.01433 12.4453C6.19313 12.4453 6.37207 12.3776 6.50926 12.2418C7.16048 11.5966 8.11519 11.1797 8.94177 11.1797H8.94205H8.993H8.99341C9.52405 11.1797 10.114 11.3501 10.6547 11.6595C10.6615 11.6634 10.6687 11.6664 10.6757 11.6701L16.7997 17.7941C16.9369 17.9313 17.117 18 17.2969 18C17.4768 18 17.6568 17.9313 17.794 17.7941C18.0687 17.5195 18.0687 17.0743 17.794 16.7997Z"
        fill={color ? color : opaque ? `${theme.neutral5}35` : theme.neutral5}
      />
    </svg>
  );
};
